import { setPflFilters } from '../state/actions/filtersCacheActions';
import { useState, useEffect } from 'react';
import axios from 'axios';
import { useDispatch, useSelector } from 'react-redux';

import { ApplicationState } from '../types/state/storeTypes';
import { FetchHookResponse } from '../types/hooks/hooksTypes';
import { AxiosResponse, AxiosError } from 'axios';
import { FetchFilterOption } from '../types/api/FiltersTypes';
import { GenericResponse } from '../types/api/Http';0

export default function getPflFilters(): FetchHookResponse<Array<FetchFilterOption>> {
  const filtersUrl = `/scenes/fetch-filters?limit=50`

  const dispatch = useDispatch();
  const state: ApplicationState = useSelector((state) => state) as ApplicationState;

  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string>(null);

  useEffect(() => {
    if (!!state.filtersCache.pflFilters.length) return;

    const fetchPflFilters = () => {
      dispatch({
        type: '',
        api: {
          method: 'GET',
          url: filtersUrl,
          onError: (res: AxiosError) => {
            setLoading(false);
            setError((res as AxiosError).message);
            return false;
          },
          onSuccess: (res: AxiosResponse<GenericResponse<Array<FetchFilterOption>>>) => {
            const data = res.data.data.sort((a, b) => a.option_type.id - b.option_type.id);
            dispatch(setPflFilters(data));
            setLoading(false);
          }
        }
      });
    }

    fetchPflFilters();
  }, [])

  return {
    loading,
    error,
    data: state.filtersCache.pflFilters,
  };;
};
